// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  domain: 'localhost',
  useServiceWorker: false,
  version: '0.0.1',
  apiUrl: 'https://api.namo.scritalia.com/api',
  idbOptions: {
    name: 'NXT',
    items: ['GridStatus', 'Notifications', 'GlobalSettings'],
    version: 4,
  },
  recaptcha: {
    siteKey: '6LezVycrAAAAAJ6duxXs8oBjdd7suBEif7DZCn1w',
    secretKey: '6LezVycrAAAAAHKGzfEe7qiT2OFIzFSfJ9b4CB_5',
  },
  hub: 'https://api.namo.scritalia.com/hub',
  hubEndpoints: {
    retst: 'test',
    uState: 'uState',
  },

  //customizations
  appColor: '#F7F737', //this is the 500 color value, the color in the middle ya know, so not the darkest or the lightest, in the middle
  //if you change this color you need to change the one for angular material, use this command and give the color
  //ng generate @angular/material:m3-theme
  logo: `assets/images/namo_logo.png`,
  logoDark: `assets/images/namo_logo.png`,
  logoMicrosoft: `assets/images/mcst_logo.svg`,
  appName: 'NXT',
  textFieldRegex: "^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\\-_.@#$%&*+,;?!:()' \\n\\r€]+$",

  theme: {
    darkThemePath:
      'assets/theme/ej2-tailwind-dark-theme/styles/tailwind-dark.css',
    lightThemePath: './assets/theme/ej2-tailwind-theme/styles/tailwind.css',
  },

  baseHREF: '',
  apiErrorCodes: {
    InvalidData: 'INVDAT0001',
    DBError: 'DBQERR0002',
    MissingData: 'MISDAT0003',
    DataDeleted: 'DATDEL0004',
    DataExist: 'DATEXS0005',
    DataInvalidFormat: 'DAINVF0006',
    NotFound: '404NOF0007',
    DataExpired: 'EXPDAT0008',
    AccessForbiden: 'ACCFOR0009',
    UserAlreadyLogedin: 'ULOGED0010',
    LockedField: 'FIELOK0011',
    TooManyAttempts: 'TMLOAT0012',
    InvalidFileFormat: 'INVFIF0013',
    MissingPrinter: '404LPR0014',
    NotAvailablePrinter: 'LPPNAV0015',
    UserTokenError: 'USTKER0016',
    TokenErrorWithDetails: 'You need to be authenticated to use this API',
    ClienteExistWithPiva: 'CLPVEX0018',
    CantCompleteAction: 'ACTFOR0019',
    IncorectFileExtension: 'FILEEX40021',
  },
  idbTables: {
    GridStatus: 'GridStatus',
    Notifications: 'Notifications',
    GlobalSettings: 'GlobalSettings',
    OrdineTestata: 'OrdineTestata',
    OrdineDettaglio: 'OrdineDettaglio',
    OrdiniReady: 'OrdiniReady',
    CalcPrezzo: 'CalcPrezzo',
    Promozioni: 'Promozioni',
    DropDowns: {
      DDClienti: 'DDClienti',
      DDSediCliente: 'DDSediCliente',
      DDArticoli: 'DDArticoli',
      DDVarianti: 'DDVarianti',
      DDGiorniLavorativiSettimana: 'DDGiorniLavorativiSettimana',
    },
  },
  UserRoles: {
    superAdmin: 1,
    developer: 2,
    admin: 3,
    magazziniere: 4,
    ticketManager: 5,
    amministrazione: 6,
    trasportatore: 7,
    clienteCommittente: 8,
    clienteDestinatario: 9,
    autista: 10,
    apiOnly: 11,
    ufficioAcquisti: 12,
  },

  TipoArticoli: {
    Guide: 8,
    Sporgere: 9,
    Tappi: 10,
    Terminali: 11,
    Catenacci: 12,
    Tapparelle: 13,
    Avvolgibili: 14,
  },
  TipoAttivita: {
    attivita: 1,
    ferie: 2,
    permessi: 3,
    malattia: 4,
    formazione: 5,
    sopralluoghi: 6,
    ricercaESviluppo: 7,
    ticket: 8,
    commessa: 9,
  },
  StaoAttivita: {
    aperta: 1,
    presoInCarico: 2,
    assegnata: 3,
    daOrdinare: 4,
    attesaMateriale: 5,
    daPianificare: 6,
    attesaCliente: 7,
    chiusa: 8,
  },
  clientStatusCollection: {
    good: 'Il cliente è in regola con i pagamenti',
    mid: 'Il cliente è in regola con i pagamenti',
    bad: 'Il cliente NON è in regola con i pagamenti',
  },

  MicrosoftLoginData: {
    clientId: '801c9e65-417f-433a-af17-2cf20ec8672d',
    tenantId: '38baea84-147a-4ce9-b603-b4c342aa83b8',
    redirectUri: 'https://192.168.114.142:4200/login',
    apiSecret: 'api://801c9e65-417f-433a-af17-2cf20ec8672d/Forecast.Read',
    apiSecretPermissionArray: ['user.read'],

    secretKey: {
      value: '2uT8Q~Cmp6txit7OYnqPwVNL5f1-IqBpXMCl_a6K',
      id: 'cc2ce98b-a9c1-4e52-8665-e594c08ae29f',
    },
  },
  options: {
    allowMasterdataDelete: true,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
